import { createPathComponent } from "@react-leaflet/core"
import type { LeafletContextInterface, PathProps } from "@react-leaflet/core"
import type { LatLng } from "leaflet"
import type { PropsWithChildren } from "react"
import { rectangleOverwrite } from "../../../utils"
import type { RectangleOverwriteLayer } from "../../../utils"

export interface IRectangleShapeOverwriteProps extends PathProps {
  corner1: LatLng
  corner2: LatLng
}

export const RectangleShapeOverwrite = createPathComponent<
  RectangleOverwriteLayer,
  PropsWithChildren<IRectangleShapeOverwriteProps>
>(
  ({ corner1, corner2, ...options }, ctx: LeafletContextInterface) => {
    const instance: RectangleOverwriteLayer = new rectangleOverwrite(corner1, corner2, options)
    return { instance, context: { ...ctx, overlayContainer: instance } }
  },
  (layer: RectangleOverwriteLayer, props: IRectangleShapeOverwriteProps, prevProps: IRectangleShapeOverwriteProps) => {
    if (props.corner1 !== prevProps.corner1 || props.corner2 !== prevProps.corner2) {
      ;(layer as any).setBounds(props.corner1, props.corner2)
    }
  }
)
